<app-loading *ngIf="carInformacionInicial"></app-loading>
<div *ngIf="!carInformacionInicial">

  <form [formGroup]="formulario">

  </form>
</div>
